import { render, staticRenderFns } from "./receipt-detail-pay.vue?vue&type=template&id=5ac2655b"
import script from "./receipt-detail-pay.vue?vue&type=script&lang=js"
export * from "./receipt-detail-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports